import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Tooltip from "../../Common/Tooltip";
import { useForm } from "react-hook-form";
//import { messageService } from "../../Services/message.service";

import { convertToPdf } from "../../../Services/PDFservice/invoiceToPdf.service";
import ResultModal from "../../Common/ResultModal";
import { tr } from "date-fns/locale";

const EmailModal = ({
  show,
  handleHide,
  invoiceDetails,
  invoiceDetailsItems,
  invoiceDetailsPayments,
  invoiceDetailsTaxes,
  base64QR,
}) => {
  const { t: translator } = useTranslation();
  const { register, handleSubmit, errors, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [serverError, setServerError] = useState(null);
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const handleClose = () => {
    setModal({ show: false });
  };

  const confirmSent = (data) => {
   
    handleHide();
    var data = convertToPdf.sendPdfToMail(
      invoiceDetails,
      invoiceDetailsItems,
      invoiceDetailsPayments,
      invoiceDetailsTaxes,
      translator,
      base64QR,
      data.email
    );

    console.log(data);
    /*messageService
      .createPos({
        tenantId: tenantId,
        posId: Number(posId),
        title: data.title,
        text: data.text,
      })
      .then((res) => {
        if (res.status === 200) {
          handleHide();
          setModal({
            show: true,
            title: translator("SendMessage-SuccessModal-Title"),
            text: translator("SendMessage-SuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: true,
          });
        } else {
          setServerError(res.data.errors[0].value);
        }
      })
      .catch((err) => {
        setServerError(err);
      });*/
  };

  return (
    <>
      <Modal show={show} onHide={handleHide} centered>
        <Modal.Header>
          <Modal.Title>{translator("Invoice-SendMail")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>{translator("Invoice-SendMail-Email")}</label>{" "}
            <Tooltip text={translator("Invoice-SendMail-Msg")} />
            <input
              type="text"
              className="form-control"
              ref={register({
                required: true,
                maxLength: 200,
              })}
              name="email"
            />
            {errors.title && errors.title.type === "required" && (
              <p className="text-danger">
                {translator("ValidationMsg-RequiredField")}
              </p>
            )}
            {errors.title && errors.title.type === "maxLength" && (
              <p className="text-danger">
                {translator("ValidationMsg-MaxLength200")}
              </p>
            )}
          </div>

          {serverError && <p className="text-danger">{serverError}</p>}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            data-dismiss="modal"
            onClick={handleHide}
          >
            {translator("General-Close")}
          </button>
          <button
            onClick={handleSubmit(confirmSent)}
            type="button"
            className="btn btn-primary"
          >
            {translator("Btn-Send")}
          </button>
        </Modal.Footer>
      </Modal>

      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </>
  );
};

export default EmailModal;
